export const round = (value: number, fixed = 1): number => {
  return Math.round(value * 10 ** fixed) / 10 ** fixed;
};

export const calculatePercentage = (value: number, total: number): number =>
  total === 0 ? 0 : (value / total) * 100;
